<!-- <span title={{comment}}>{{comment}}</span> -->
<span title="{{comment | translate}}" *ngIf="isMCModule; else commentBlock">{{comment | translate}}</span>
<ng-template #commentBlock>{{comment}}</ng-template>